<template>
  <div class="name">

    <!-- <el-row class="bgW">
      <el-col :span="20">
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="产品名称">
            <el-input
              v-model="search.name"
              maxlength="30"
              clearable
              placeholder="请输入产品名称"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status" clearable placeholder="请选择状态">
              <el-option
                v-for="item in options.statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <el-button type="primary" size="mini" @click="getList('resetForm')">重置</el-button>
      </el-col>
    </el-row> -->
    <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog">添加</el-button>
    </div>
    <div class="accountCon">
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column label="编号" width="55" >
              <template slot-scope="{ row }">
                {{ row.scar}}{{ row.acne}}{{ row.sclererythrin}}{{ row.color_stain}}{{ row.wrinkle }}
              </template>
            </el-table-column>
            <el-table-column label="敏感" width="50" align="center">
              <template slot-scope="{ row }">
                {{ row.scar}}
              </template>
            </el-table-column>
            <el-table-column label="痤疮" width="50" align="center">
              <template slot-scope="{ row }">
                {{ row.acne}}
              </template>
            </el-table-column>
            <el-table-column label="紫质" width="50" align="center">
              <template slot-scope="{ row }">
                {{ row.sclererythrin }}
              </template>
            </el-table-column>
            <el-table-column label="色斑" width="50" align="center">
              <template slot-scope="{ row }">
                {{ row.color_stain}}
              </template>
            </el-table-column>
            <el-table-column label="皱纹" width="50" align="center">
              <template slot-scope="{ row }">
                {{ row.wrinkle}}
              </template>
            </el-table-column>
            <el-table-column label="精粹水" prop="treatment_lotion_list" min-width="80" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <div v-if="row.treatment_lotion_list">
                  <div v-for="(item,idx) in row.treatment_lotion_list" :key="idx">{{ item }}</div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="商品" prop="shop_goods_list" min-width="80" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <div v-if="row.shop_goods_list">
                  <div v-for="(item,idx) in row.shop_goods_list" :key="idx">{{ item }}</div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="品项" min-width="80" show-overflow-tooltip>
              <template slot-scope="{ row }">
              <div v-if="row.product_item">
                <div v-for="(item,idx) in row.product_item" :key="idx">{{ item.product_item_name }}({{ item.product_item_frequency }})</div>
              </div>
              <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="品项组合" min-width="120">
              <template slot-scope="{ row }">
                 <div v-if="row.combination">
                <div v-for="(item,idx) in row.combination_list
" :key="idx">{{ item }}</div>
              </div>
              <span v-else>-</span>
              </template>
            </el-table-column>


            <el-table-column label="定制化产品" min-width="80">
              <template slot-scope="{ row }">
                {{ row.product_name || (row.custom_product_id || '-') }}
              </template>
            </el-table-column>
            <el-table-column label="状态" width="140" align="center">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="2"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="handleStatusChange(row)"
                />
              </template>
            </el-table-column>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="新增定制化护理"
      :visible.sync="dialogVisible"
      width="640px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form label-width="110px" size="small">
        <el-row>
          <el-col :span="7">
            <el-form-item label="敏感：">
              <el-select v-model="form.scar" class="dim-select" @change="autoFillProduct">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="痤疮：">
              <el-select v-model="form.acne" class="dim-select" @change="autoFillProduct">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="紫质：">
              <el-select v-model="form.sclererythrin" class="dim-select" @change="autoFillProduct">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="色斑：">
              <el-select v-model="form.color_stain" class="dim-select" @change="autoFillProduct">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="皱纹：">
              <el-select v-model="form.wrinkle" class="dim-select" @change="autoFillProduct">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="20">
            <el-form-item label="复合组合：" required>
              <el-input v-model="form.custom_product_code" placeholder="请选择五维三度" readonly />
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          
          <el-col :span="20">
            <el-form-item label="品项：">
              <el-select
                v-model="form.product_item"
                multiple
                filterable
                clearable
                placeholder="请选择品项"
                class="product-select"
              >
                <el-option
                  v-for="item in itemOptions"
                  :key="item.id"
                  :label="item.item_name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="20">
            <el-form-item label="品项组合：">
              <el-select
                v-model="form.combination"
                multiple
                filterable
                clearable
                placeholder="请选择品项组合"
                class="product-select"
              >
                <el-option
                  v-for="item in itemOptions"
                  :key="item.id"
                  :label="item.item_name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="品项频次：">
              <el-input v-model="form.item_frequency" clearable placeholder="请输入品项频次" />
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="精粹水：">
              <el-select
                v-model="form.treatment_lotion"
                multiple
                filterable
                clearable
                placeholder="请选择精粹水"
                class="product-select"
              >
                <el-option
                  v-for="item in waterOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="商品：">
               <el-select
                v-model="form.shop_goods_id"
                multiple
                filterable
                clearable
                placeholder="请选择商品"
                class="product-select"
                remote
                :remote-method="getGoodsList"
              >
                <el-option
                  v-for="item in goodsOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import { getFiveThreeList, getFivethreeGoods, getMaterialList, createFiveThree, updateFiveThreeStatus, getProductItemList, getFivethreeProduct } from '@/api/goods'

class Page {
  total = 0;
  page = 1;
  pagesize = 10;
}
class Search {
  product_name = '';
  status = '';
}
export default {
  name: 'FinalGroupList',
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      list: [],
      dialogVisible: false,
      productLoading: false,
      itemOptions: [],
      goodsOptions: [],
      waterOptions: [],
      levelList: [
        { label: 0, value: 0 },
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 }
      ],
      form: {
        scar: 0,
        acne: 0,
        sclererythrin: 0,
        color_stain: 0,
        wrinkle: 0,
        product_item: [],
        combination: [],
        item_frequency: '',
        treatment_lotion: [],
        shop_goods_id: [],
        custom_product_id: null,
        custom_product_code: ''
      }
    }
  },
  mounted() {
    this.getList();
    this.getItemOptions();
  },
  methods: {
    getList(option) {
      if (option === 'resetForm') { this.search = new Search(); this.page = new Page(); }
      if (option === 'search') this.page = new Page();
      getFiveThreeList({ ...this.search, ...this.page }).then(res => {
        this.list = res.data.list;
        this.page.total = res.data.dataCount;
      });
    },
    handleStatusChange(row) {
       updateFiveThreeStatus({ id: row.id, status: row.status }).then(res => {
        this.$message({
          type: 'success',
          message: res.msg
        });
      }).catch(() => {
        row.status = row.status === 1 ? 2 : 1;
      });
    },
    // 打开新增弹窗
    openDialog() {
      this.dialogVisible = true;
      this.resetForm();
    },
    // 关闭弹窗重置表单
    resetForm() {
      this.form = {
        scar: 0,
        acne: 0,
        sclererythrin: 0,
        color_stain: 0,
        wrinkle: 0,
        product_item: [],
        item_frequency: '',
        treatment_lotion: [],
        shop_goods_id: [],
        custom_product_id: null,
        custom_product_code: ''
      };
    },
    autoFillProduct() {
      const f = this.form;
      getFivethreeProduct({
        scar: f.scar,
        acne: f.acne,
        sclererythrin: f.sclererythrin,
        color_stain: f.color_stain,
        wrinkle: f.wrinkle
      }).then(res => {
        this.form.custom_product_id = res.data?.list?.[0]?.id || null;
        this.form.custom_product_code = res.data?.list?.[0]?.code || '';
      });
    },
    getGoodsList(query) {
      getFivethreeGoods({ name: query }).then(res => {
        this.goodsOptions = (res.data && res.data.list) || [];
      });
    },
    getItemOptions() {
      getProductItemList({ is_select:1}).then(res => {
        this.itemOptions = (res.data && res.data.list) || [];
      });
      getMaterialList({ is_select:1}).then(res => {
        this.waterOptions = (res.data && res.data.list) || [];
      });
      getFivethreeGoods().then(res => {
        this.goodsOptions = (res.data && res.data.list) || [];
      });
    },
    // 保存
    submitForm() {
      const f = this.form;
      createFiveThree({
        scar: f.scar,
        acne: f.acne,
        combination: f.combination,
        sclererythrin: f.sclererythrin,
        color_stain: f.color_stain,
        wrinkle: f.wrinkle,
        product_item: f.product_item,
        item_frequency: f.item_frequency,
        treatment_lotion: f.treatment_lotion,
        shop_goods_id: f.shop_goods_id,
        // custom_product_id: f.custom_product_id || 0
      }).then(res => {
        this.$message({ type: 'success', message: res.msg || '添加成功' });
        this.dialogVisible = false;
        this.getList('search');
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.accountCon {
  background: #fff;
  padding: 10px 0 80px;
}
.compound-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 12px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
  .form-item {
    display: flex;
    align-items: center;
    .form-label {
      font-size: 13px;
      color: #606266;
      font-weight: 600;
      margin-right: 6px;
    }
    .header-price {
      width: 120px;
    }
    .header-remark {
      width: 260px;
    }
  }
}
.compound-wrap {
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 6px;
}
.tube-block {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  .tube-head {
    margin-bottom: 10px;
    .tube-name {
      font-weight: 600;
      font-size: 14px;
      color: #303133;
    }
  }
  .tube-table {
    margin-bottom: 6px;
    .select-inline {
      width: 200px;
    }
    .qty-inline {
      width: 100px;
    }
  }
}
.header-center {
  text-align: center !important;
}
.dim-tag {
  display: inline-block;
  margin-left: 4px;
  padding: 0 4px;
  font-size: 11px;
  color: #909399;
  background: #f0f2f5;
  border-radius: 2px;
}
.dim-select {
  width: 110px;
}
.product-select {
  width: 100%;
}
</style>
